import { CriterePondere } from './CriterePondere';

export class TypeCrJugement {

  public critereCDC: string;

  public critereLibre: string[];

  public criterePondere: CriterePondere[];

  public criterePrix: string;

  constructor() {
    this.critereCDC = '';
    this.critereLibre = [];
    this.criterePondere = [];
    this.criterePrix = '';

  }
}
